module.exports = __webpack_public_path__ + "static/img/bank.a1bf0c53.png";